
import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

export default function GeographyMaster() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [summary, setSummary] = useState(null);
  const [geoRows, setGeoRows] = useState([]);
  const [geoSearch, setGeoSearch] = useState("");
  const [geoLoading, setGeoLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [panchayats, setPanchayats] = useState([]);

  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedDistrictId, setSelectedDistrictId] = useState("");
  const [selectedBlockId, setSelectedBlockId] = useState("");
  const [selectedPanchayatId, setSelectedPanchayatId] = useState("");

  const [stateForm, setStateForm] = useState({ name: "", code: "" });
  const [districtForm, setDistrictForm] = useState({ name: "", code: "" });
  const [blockForm, setBlockForm] = useState({ name: "", code: "" });
  const [panchayatForm, setPanchayatForm] = useState({ name: "", code: "" });
  const [villageForm, setVillageForm] = useState({ name: "", code: "" });
  const [geoTotal, setGeoTotal] = useState(0);
  const [fpos, setFpos] = useState([]);
  const [mappingFpoId, setMappingFpoId] = useState("");
  const [mappingDistrictIds, setMappingDistrictIds] = useState([]);
  const [mappingBlockIds, setMappingBlockIds] = useState([]);
  const [mappingLoading, setMappingLoading] = useState(false);

  const handleUpload = async (e) => {
    e.preventDefault();

    setMessage("");
    setSummary(null);

    if (!file) {
      setMessage("Please select an Excel file");
      return;
    }

    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file", file);

      const res = await fetch(`${API_BASE}/geography/upload`, {
        method: "POST",
        headers: authHeaders(),
        body: formData,
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        setSummary(data.summary || null);
        throw new Error(data.message || "Upload failed");
      }

      const uploadSummary = data.summary || null;

      if (
        uploadSummary &&
        Number(uploadSummary.villages_created || 0) === 0 &&
        Number(uploadSummary.states_created || 0) === 0 &&
        Number(uploadSummary.districts_created || 0) === 0 &&
        Number(uploadSummary.blocks_created || 0) === 0 &&
        Number(uploadSummary.panchayats_created || 0) === 0 &&
        Number(uploadSummary.reused || 0) > 0
      ) {
        setMessage(
          "Upload completed. Existing geography records were reused. No duplicate records created."
        );
      } else {
        setMessage(data.message || "Geography uploaded successfully");
      }

      setSummary(uploadSummary);
      await loadGeography();
      setFile(null);

      const input = document.getElementById("geo-upload-file");
      if (input) input.value = "";
    } catch (err) {
      console.error("Geography upload error:", err);
      setMessage(err.message || "Upload failed");
    } finally {
      setUploading(false);
    }
  };



  const loadGeography = async () => {
    setGeoLoading(true);

    try {
      const params = new URLSearchParams({
        limit: "100",
        offset: "0",
      });

      if (geoSearch.trim()) {
        params.set("search", geoSearch.trim());
      }

      const res = await fetch(
        `${API_BASE}/geography/list?${params.toString()}`,
        {
          headers: authHeaders(),
        }
      );

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to load geography");
      }

      setGeoRows(Array.isArray(data.data) ? data.data : []);
      setGeoTotal(data.pagination?.total || 0);
    } catch (err) {
      console.error("Load geography error:", err);
      setMessage(err.message || "Failed to load geography");
    } finally {
      setGeoLoading(false);
    }
  };

  const loadStates = async () => {
    const res = await fetch(`${API_BASE}/geography/states`, {
      headers: authHeaders(),
    });

    const data = await res.json();

    if (!res.ok || data.success === false) {
      throw new Error(data.message || "Failed to load states");
    }

    setStates(Array.isArray(data.data) ? data.data : []);
  };

  const loadDistricts = async (stateId) => {
    setDistricts([]);
    setBlocks([]);
    setPanchayats([]);
    setSelectedDistrictId("");
    setSelectedBlockId("");
    setSelectedPanchayatId("");

    const url = stateId
      ? `${API_BASE}/geography/districts?state_id=${stateId}`
      : `${API_BASE}/geography/districts`;

    const res = await fetch(url, {
      headers: authHeaders(),
    });

    const data = await res.json();

    if (!res.ok || data.success === false) {
      throw new Error(data.message || "Failed to load districts");
    }

    setDistricts(Array.isArray(data.data) ? data.data : []);
  };

  const loadBlocks = async (districtId) => {
    setBlocks([]);
    setPanchayats([]);
    setSelectedBlockId("");
    setSelectedPanchayatId("");

    const url = districtId
      ? `${API_BASE}/geography/blocks?district_id=${districtId}`
      : `${API_BASE}/geography/blocks`;

    const res = await fetch(url, {
      headers: authHeaders(),
    });

    const data = await res.json();

    if (!res.ok || data.success === false) {
      throw new Error(data.message || "Failed to load blocks");
    }

    setBlocks(Array.isArray(data.data) ? data.data : []);
  };

  const loadPanchayats = async (blockId) => {
    setPanchayats([]);
    setSelectedPanchayatId("");

    if (!blockId) return;

    const res = await fetch(`${API_BASE}/geography/panchayats?block_id=${blockId}`, {
      headers: authHeaders(),
    });

    const data = await res.json();

    if (!res.ok || data.success === false) {
      throw new Error(data.message || "Failed to load panchayats");
    }

    setPanchayats(Array.isArray(data.data) ? data.data : []);
  };
  const createState = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await fetch(`${API_BASE}/geography/states`, {
        method: "POST",
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify(stateForm),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to create state");
      }

      setMessage(data.message || "State saved");
      setStateForm({ name: "", code: "" });
      await loadStates();
      await loadGeography();
    } catch (err) {
      setMessage(err.message || "Failed to create state");
    }
  };

  const createDistrict = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!selectedStateId) {
      setMessage("Please select State");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/geography/districts`, {
        method: "POST",
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          state_id: Number(selectedStateId),
          ...districtForm,
        }),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to create district");
      }

      setMessage(data.message || "District saved");
      setDistrictForm({ name: "", code: "" });
      await loadDistricts(selectedStateId);
      await loadGeography();
    } catch (err) {
      setMessage(err.message || "Failed to create district");
    }
  };

  const createBlock = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!selectedDistrictId) {
      setMessage("Please select District");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/geography/blocks`, {
        method: "POST",
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          district_id: Number(selectedDistrictId),
          ...blockForm,
        }),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to create block");
      }

      setMessage(data.message || "Block saved");
      setBlockForm({ name: "", code: "" });
      await loadBlocks(selectedDistrictId);
      await loadGeography();
    } catch (err) {
      setMessage(err.message || "Failed to create block");
    }
  };

  const createPanchayat = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!selectedBlockId) {
      setMessage("Please select Block");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/geography/panchayats`, {
        method: "POST",
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          block_id: Number(selectedBlockId),
          ...panchayatForm,
        }),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to create panchayat");
      }

      setMessage(data.message || "Panchayat saved");
      setPanchayatForm({ name: "", code: "" });
      await loadPanchayats(selectedBlockId);
      await loadGeography();
    } catch (err) {
      setMessage(err.message || "Failed to create panchayat");
    }
  };

  const createVillage = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!selectedPanchayatId) {
      setMessage("Please select Panchayat");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/geography/villages`, {
        method: "POST",
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          panchayat_id: Number(selectedPanchayatId),
          ...villageForm,
        }),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to create village");
      }

      setMessage(data.message || "Village saved");
      setVillageForm({ name: "", code: "" });
      await loadGeography();
    } catch (err) {
      setMessage(err.message || "Failed to create village");
    }
  };

  const toggleId = (list, id) => {
    const strId = String(id);

    if (list.map(String).includes(strId)) {
      return list.filter((x) => String(x) !== strId);
    }

    return [...list, strId];
  };

  const loadFpos = async () => {
    const res = await fetch(`${API_BASE}/fpos`, {
      headers: authHeaders(),
    });

    const data = await res.json();

    if (!res.ok || data.success === false) {
      throw new Error(data.message || "Failed to load FPOs");
    }

    setFpos(Array.isArray(data.data) ? data.data : []);
  };

  const loadFpoMapping = async (fpoId) => {
    setMappingDistrictIds([]);
    setMappingBlockIds([]);

    if (!fpoId) return;

    setMappingLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${API_BASE}/geography/fpo-mapping/${fpoId}`, {
        headers: authHeaders(),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to load FPO geography mapping");
      }

      setMappingDistrictIds(
        Array.isArray(data.data?.district_ids)
          ? data.data.district_ids.map(String)
          : []
      );

      setMappingBlockIds(
        Array.isArray(data.data?.block_ids)
          ? data.data.block_ids.map(String)
          : []
      );
    } catch (err) {
      console.error("Load FPO mapping error:", err);
      setMessage(err.message || "Failed to load FPO geography mapping");
    } finally {
      setMappingLoading(false);
    }
  };

  const saveFpoMapping = async () => {
    if (!mappingFpoId) {
      setMessage("Please select FPO");
      return;
    }

    if (mappingDistrictIds.length === 0 && mappingBlockIds.length === 0) {
      setMessage("Please select at least one district or block");
      return;
    }

    setMappingLoading(true);
    setMessage("");

    try {
      const res = await fetch(
        `${API_BASE}/geography/fpo-mapping/${mappingFpoId}`,
        {
          method: "POST",
          headers: authHeaders({
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            district_ids: mappingDistrictIds.map(Number),
            block_ids: mappingBlockIds.map(Number),
          }),
        }
      );

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to save mapping");
      }

      setMessage(data.message || "FPO geography mapping saved successfully");

      setMappingDistrictIds(
        Array.isArray(data.data?.district_ids)
          ? data.data.district_ids.map(String)
          : mappingDistrictIds
      );

      setMappingBlockIds(
        Array.isArray(data.data?.block_ids)
          ? data.data.block_ids.map(String)
          : mappingBlockIds
      );
    } catch (err) {
      console.error("Save FPO mapping error:", err);
      setMessage(err.message || "Failed to save mapping");
    } finally {
      setMappingLoading(false);
    }
  };

  useEffect(() => {
    loadGeography();
    loadStates();
    loadFpos();
    loadDistricts("");
    loadBlocks("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />

      <div style={{ padding: 24, width: "100%" }}>
        <h2>Geography Master</h2>

        <p style={{ color: "#555" }}>
          Upload State, District, Block, Panchayat and Village master data.
          This section is available only to Super Admin.
        </p>

        <div
          style={{
            marginBottom: 20,
            padding: 16,
            border: "1px solid #ddd",
            background: "#fafafa",
          }}
        >
          <h3>Required Excel Format</h3>

          <table
            border="1"
            cellPadding="8"
            cellSpacing="0"
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            <thead>
              <tr style={{ background: "#f0f0f0" }}>
                <th>State Name</th>
                <th>State Code</th>
                <th>District Name</th>
                <th>District Code</th>
                <th>Block Name</th>
                <th>Block Code</th>
                <th>Panchayat Name</th>
                <th>Panchayat Code</th>
                <th>Village Name</th>
                <th>Village Code</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Bihar</td>
                <td>10</td>
                <td>Banka</td>
                <td>225</td>
                <td>Katoria</td>
                <td>1583</td>
                <td>Example Panchayat</td>
                <td>123456</td>
                <td>Example Village</td>
                <td>123456789</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          style={{
            marginBottom: 20,
            padding: 16,
            border: "1px solid #ddd",
            background: "#fff",
          }}
        >
          <h3>Manual Add Geography</h3>

          <p style={{ color: "#555" }}>
            Add geography level-wise. Codes are mandatory. Use dropdowns to add lower levels under the correct parent.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(300px, 1fr))",
              gap: 16,
            }}
          >
            <form
              onSubmit={createState}
              style={{ padding: 12, border: "1px solid #eee" }}
            >
              <h4>Add State</h4>

              <input
                placeholder="State Name"
                value={stateForm.name}
                onChange={(e) =>
                  setStateForm({ ...stateForm, name: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <input
                placeholder="State Code"
                value={stateForm.code}
                onChange={(e) =>
                  setStateForm({ ...stateForm, code: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <button type="submit" style={{ padding: "8px 12px" }}>
                Add State
              </button>
            </form>

            <form
              onSubmit={createDistrict}
              style={{ padding: 12, border: "1px solid #eee" }}
            >
              <h4>Add District</h4>

              <select
                value={selectedStateId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedStateId(value);
                  await loadDistricts(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select State</option>
                {states.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name} {s.code ? `(${s.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <input
                placeholder="District Name"
                value={districtForm.name}
                onChange={(e) =>
                  setDistrictForm({ ...districtForm, name: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <input
                placeholder="District Code"
                value={districtForm.code}
                onChange={(e) =>
                  setDistrictForm({ ...districtForm, code: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <button type="submit" style={{ padding: "8px 12px" }}>
                Add District
              </button>
            </form>

            <form
              onSubmit={createBlock}
              style={{ padding: 12, border: "1px solid #eee" }}
            >
              <h4>Add Block</h4>

              <select
                value={selectedStateId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedStateId(value);
                  await loadDistricts(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select State</option>
                {states.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name} {s.code ? `(${s.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <select
                value={selectedDistrictId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedDistrictId(value);
                  await loadBlocks(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select District</option>
                {districts.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name} {d.code ? `(${d.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <input
                placeholder="Block Name"
                value={blockForm.name}
                onChange={(e) =>
                  setBlockForm({ ...blockForm, name: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <input
                placeholder="Block Code"
                value={blockForm.code}
                onChange={(e) =>
                  setBlockForm({ ...blockForm, code: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <button type="submit" style={{ padding: "8px 12px" }}>
                Add Block
              </button>
            </form>

            <form
              onSubmit={createPanchayat}
              style={{ padding: 12, border: "1px solid #eee" }}
            >
              <h4>Add Panchayat</h4>

              <select
                value={selectedStateId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedStateId(value);
                  await loadDistricts(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select State</option>
                {states.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name} {s.code ? `(${s.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <select
                value={selectedDistrictId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedDistrictId(value);
                  await loadBlocks(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select District</option>
                {districts.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name} {d.code ? `(${d.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <select
                value={selectedBlockId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedBlockId(value);
                  await loadPanchayats(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select Block</option>
                {blocks.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name} {b.code ? `(${b.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <input
                placeholder="Panchayat Name"
                value={panchayatForm.name}
                onChange={(e) =>
                  setPanchayatForm({ ...panchayatForm, name: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <input
                placeholder="Panchayat Code"
                value={panchayatForm.code}
                onChange={(e) =>
                  setPanchayatForm({ ...panchayatForm, code: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <button type="submit" style={{ padding: "8px 12px" }}>
                Add Panchayat
              </button>
            </form>

            <form
              onSubmit={createVillage}
              style={{ padding: 12, border: "1px solid #eee" }}
            >
              <h4>Add Village</h4>

              <select
                value={selectedStateId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedStateId(value);
                  await loadDistricts(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select State</option>
                {states.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name} {s.code ? `(${s.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <select
                value={selectedDistrictId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedDistrictId(value);
                  await loadBlocks(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select District</option>
                {districts.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name} {d.code ? `(${d.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <select
                value={selectedBlockId}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedBlockId(value);
                  await loadPanchayats(value);
                }}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select Block</option>
                {blocks.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name} {b.code ? `(${b.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <select
                value={selectedPanchayatId}
                onChange={(e) => setSelectedPanchayatId(e.target.value)}
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              >
                <option value="">Select Panchayat</option>
                {panchayats.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name} {p.code ? `(${p.code})` : "(No Code)"}
                  </option>
                ))}
              </select>

              <input
                placeholder="Village Name"
                value={villageForm.name}
                onChange={(e) =>
                  setVillageForm({ ...villageForm, name: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <input
                placeholder="Village Code"
                value={villageForm.code}
                onChange={(e) =>
                  setVillageForm({ ...villageForm, code: e.target.value })
                }
                style={{ width: "100%", padding: 8, marginBottom: 8 }}
              />

              <button type="submit" style={{ padding: "8px 12px" }}>
                Add Village
              </button>
            </form>
          </div>
        </div>

        <div
          style={{
            marginBottom: 20,
            padding: 16,
            border: "1px solid #ddd",
            background: "#fff",
          }}
        >
          <h3>Map Geography to FPO</h3>

          <p style={{ color: "#555" }}>
            Select which districts and blocks are available to an FPO. FPO Admin will only see mapped geography in forms.
          </p>

          <div style={{ marginBottom: 16 }}>
            <label>Select FPO</label>
            <br />
            <select
              value={mappingFpoId}
              onChange={async (e) => {
                const value = e.target.value;
                setMappingFpoId(value);
                await loadFpoMapping(value);
              }}
              style={{ padding: 8, minWidth: 320 }}
            >
              <option value="">Select FPO</option>
              {fpos.map((fpo) => (
                <option key={fpo.id} value={fpo.id}>
                  {fpo.name} #{fpo.id}
                </option>
              ))}
            </select>
          </div>

          {mappingFpoId && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 20,
                  alignItems: "start",
                }}
              >
                <div
                  style={{
                    border: "1px solid #eee",
                    padding: 12,
                    maxHeight: 350,
                    overflowY: "auto",
                  }}
                >
                  <h4>Districts</h4>

                  {districts.length === 0 ? (
                    <p>No districts found</p>
                  ) : (
                    districts.map((district) => (
                      <label
                        key={district.id}
                        style={{
                          display: "block",
                          marginBottom: 8,
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={mappingDistrictIds.includes(String(district.id))}
                          onChange={() =>
                            setMappingDistrictIds((prev) =>
                              toggleId(prev, district.id)
                            )
                          }
                        />{" "}
                        {district.name} {district.code ? `(${district.code})` : "(No Code)"}
                      </label>
                    ))
                  )}
                </div>

                <div
                  style={{
                    border: "1px solid #eee",
                    padding: 12,
                    maxHeight: 350,
                    overflowY: "auto",
                  }}
                >
                  <h4>Blocks</h4>

                  {blocks.length === 0 ? (
                    <p>No blocks found</p>
                  ) : (
                    blocks.map((block) => {
                      const district = districts.find(
                        (d) => String(d.id) === String(block.district_id)
                      );

                      return (
                        <label
                          key={block.id}
                          style={{
                            display: "block",
                            marginBottom: 8,
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={mappingBlockIds.includes(String(block.id))}
                            onChange={() =>
                              setMappingBlockIds((prev) => toggleId(prev, block.id))
                            }
                          />{" "}
                          {block.name} {block.code ? `(${block.code})` : "(No Code)"}
                          {district ? ` — ${district.name}` : ""}
                        </label>
                      );
                    })
                  )}
                </div>
              </div>

              <div style={{ marginTop: 16 }}>
                <button
                  type="button"
                  onClick={saveFpoMapping}
                  disabled={mappingLoading}
                  style={{
                    padding: "9px 14px",
                    background: mappingLoading ? "#999" : "#1976D2",
                    color: "#fff",
                    border: "none",
                    cursor: mappingLoading ? "not-allowed" : "pointer",
                  }}
                >
                  {mappingLoading ? "Saving..." : "Save FPO Geography Mapping"}
                </button>
              </div>
            </>
          )}
        </div>

        {message && (
          <div
            style={{
              marginBottom: 16,
              padding: 10,
              border: "1px solid #ddd",
              background: "#f5f5f5",
            }}
          >
            {message}
          </div>
        )}

        <form
          onSubmit={handleUpload}
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <input
            id="geo-upload-file"
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={(e) => setFile(e.target.files[0] || null)}
          />

          <button
            type="submit"
            disabled={uploading}
            style={{
              padding: "8px 14px",
              background: uploading ? "#999" : "#1976D2",
              color: "#fff",
              border: "none",
              cursor: uploading ? "not-allowed" : "pointer",
            }}
          >
            {uploading ? "Uploading..." : "Upload Geography"}
          </button>
        </form>

        {summary && (
          <div
            style={{
              padding: 16,
              border: "1px solid #ddd",
              background: "#fff",
            }}
          >
            <h3>Upload Summary</h3>

            <table
              border="1"
              cellPadding="8"
              cellSpacing="0"
              style={{ borderCollapse: "collapse", minWidth: 400 }}
            >
              <tbody>
                <tr>
                  <td>Total Rows</td>
                  <td>{summary.total_rows ?? 0}</td>
                </tr>
                <tr>
                  <td>Processed</td>
                  <td>{summary.processed ?? 0}</td>
                </tr>
                <tr>
                  <td>Skipped</td>
                  <td>{summary.skipped ?? 0}</td>
                </tr>
                <tr>
                  <td>Existing / Reused Records</td>
                  <td>{summary.reused ?? 0}</td>
                </tr>
                <tr>
                  <td>States Created</td>
                  <td>{summary.states_created ?? 0}</td>
                </tr>
                <tr>
                  <td>Districts Created</td>
                  <td>{summary.districts_created ?? 0}</td>
                </tr>
                <tr>
                  <td>Blocks Created</td>
                  <td>{summary.blocks_created ?? 0}</td>
                </tr>
                <tr>
                  <td>Panchayats Created</td>
                  <td>{summary.panchayats_created ?? 0}</td>
                </tr>
                <tr>
                  <td>Villages Created</td>
                  <td>{summary.villages_created ?? 0}</td>
                </tr>
              </tbody>
            </table>

            {Array.isArray(summary.errors) && summary.errors.length > 0 && (
              <div style={{ marginTop: 20 }}>
                <h4>Skipped / Error Rows</h4>

                <table
                  border="1"
                  cellPadding="8"
                  cellSpacing="0"
                  style={{ borderCollapse: "collapse", width: "100%" }}
                >
                  <thead>
                    <tr style={{ background: "#f0f0f0" }}>
                      <th>Row</th>
                      <th>Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {summary.errors.map((err, index) => (
                      <tr key={index}>
                        <td>{err.row}</td>
                        <td>{err.message}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        <div
          style={{
            marginTop: 24,
            padding: 16,
            border: "1px solid #ddd",
            background: "#fff",
          }}
        >
          <h3>View Uploaded Geography</h3>

          <p style={{ color: "#555" }}>
            Search by State, District, Block, Panchayat, Village or any code.
          </p>

          <div
            style={{
              display: "flex",
              gap: 10,
              marginBottom: 16,
              alignItems: "center",
            }}
          >
            <input
              value={geoSearch}
              onChange={(e) => setGeoSearch(e.target.value)}
              placeholder="Search name or code"
              style={{ padding: 8, minWidth: 300 }}
            />

            <button
              type="button"
              onClick={loadGeography}
              disabled={geoLoading}
              style={{
                padding: "8px 14px",
                background: geoLoading ? "#999" : "#1976D2",
                color: "#fff",
                border: "none",
                cursor: geoLoading ? "not-allowed" : "pointer",
              }}
            >
              {geoLoading ? "Loading..." : "Search"}
            </button>

            <button
              type="button"
              onClick={() => {
                setGeoSearch("");
                setTimeout(() => loadGeography(), 0);
              }}
              style={{
                padding: "8px 14px",
                background: "#666",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              Reset
            </button>
          </div>

          <div style={{ marginBottom: 8, color: "#555" }}>
            Total Records: {geoTotal}
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              border="1"
              cellPadding="8"
              cellSpacing="0"
              style={{ borderCollapse: "collapse", width: "100%" }}
            >
              <thead>
                <tr style={{ background: "#f0f0f0" }}>
                  <th>State</th>
                  <th>State Code</th>
                  <th>District</th>
                  <th>District Code</th>
                  <th>Block</th>
                  <th>Block Code</th>
                  <th>Panchayat</th>
                  <th>Panchayat Code</th>
                  <th>Village</th>
                  <th>Village Code</th>
                </tr>
              </thead>

              <tbody>
                {geoRows.length === 0 ? (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      No geography records found
                    </td>
                  </tr>
                ) : (
                  geoRows.map((row) => (
                    <tr key={`${row.village_id}-${row.village_code}`}>
                      <td>{row.state_name}</td>
                      <td>{row.state_code}</td>
                      <td>{row.district_name}</td>
                      <td>{row.district_code}</td>
                      <td>{row.block_name}</td>
                      <td>{row.block_code}</td>
                      <td>{row.panchayat_name}</td>
                      <td>{row.panchayat_code}</td>
                      <td>{row.village_name}</td>
                      <td>{row.village_code}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

